import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["callbackRequestData", "isOpen", "onClose", "showCaptcha"];
import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { BackCallPopup } from '@fttb/common/components';
import { getCaptchaFlag } from '@fttb/common/store';
import { callbackRequestTextsShape } from '@fttb/common/types';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getBannerContentData, getBannerSettings, getBannerTitleAtAnalytics } from "../../store/blocks/banner/selectors";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { openFloatingPhone } from "../../store/FloatingPhone/actions";
import { getCurrentBannerCard, getIsFloatingPhoneWidgetOpen } from "../../store/selectors";
import { onButtonClickBannerBlock, setCurrentInfoBanner } from "../../store/infoCards/actions";
import { getCallbackRequestData } from "../../store/shared/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
import { BannersCarousel } from "./components/BannerCarousel/BannersCarousel";
import { withAnalyticsOnBlockWuthCarouselView } from "./hoc/withAnalyticsOnViewCarousel/index";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _BannerBlock = function _BannerBlock(_ref) {
  var callbackRequestData = _ref.callbackRequestData,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    showCaptcha = _ref.showCaptcha,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrap'),
    "data-t-id": "blocks-BannerBlock"
  }, /*#__PURE__*/React.createElement(BannersCarousel, props), /*#__PURE__*/React.createElement(BackCallPopup, {
    data: callbackRequestData,
    isOpen: isOpen,
    onClose: onClose,
    redesign: true,
    showCaptcha: showCaptcha
  }));
};
_BannerBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  bannersData: PropTypes.arrayOf(PropTypes.shape({
    backgroundColor: PropTypes.string,
    backgroundPosition: PropTypes.string,
    backgroundSize: PropTypes.string,
    buttonText: PropTypes.string,
    fullBackgroundOnDeviceSize: PropTypes.bool,
    img: PropTypes.shape({
      source: PropTypes.arrayOf(PropTypes.shape({
        media: PropTypes.string,
        srcset: PropTypes.string
      })),
      src: PropTypes.string,
      title: PropTypes.string
    }),
    link: PropTypes.string,
    linkTarget: PropTypes.string,
    text: PropTypes.string,
    textColor: PropTypes.string,
    textIsRight: PropTypes.bool,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    variant: PropTypes.string
  })),
  bannersSettings: PropTypes.shape({
    autoplay: PropTypes.bool,
    footnote: PropTypes.string,
    loop: PropTypes.bool,
    observeParents: PropTypes.bool,
    observer: PropTypes.bool,
    pagination: PropTypes.shape({
      clickable: PropTypes.string
    }),
    simulateTouch: PropTypes.bool,
    slidesPerView: PropTypes.number
  }),
  callBackRequestData: PropTypes.shape({
    text: PropTypes.shape(callbackRequestTextsShape)
  }),
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  showCaptcha: PropTypes.bool
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    analyticBlockTitle: getBannerTitleAtAnalytics(state),
    bannersData: getBannerContentData(state),
    bannersSettings: getBannerSettings(state),
    callbackRequestData: getCallbackRequestData(state),
    currentBanner: getCurrentBannerCard(state),
    isOpen: getIsFloatingPhoneWidgetOpen(state),
    pageType: getAnalyticEventType(state),
    shouldRender: !!getCallbackRequestData(state),
    showCaptcha: getCaptchaFlag(state)
  };
};
var mapDispatchToProps = {
  onClick: onButtonClickBannerBlock,
  onClose: openFloatingPhone,
  setCurrentBanner: setCurrentInfoBanner
};
var _BannerBlockHOC = withAnalyticsOnBlockWuthCarouselView(_BannerBlock);
export var BannerBlock = compose(defineBlock(FttbBlocks.BANNER), connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_BannerBlockHOC);